import { useMemo, useState } from 'react';
import { Bot } from 'grts-utils/types/Bot';
import { Subscription } from '../../../types/subscription';
import { ProfitChartApiResponse } from '../../Detail/Charts/types';
import { Candle } from '../../Detail/types';
import { SingleProfitCalculationApiResponse } from '../../ProfitCalculations/types';
import { ResultProvider } from '../Content/Calculations/context';
import LiveState from '../Content/Calculations/Result/LiveState';
import TransactionList from '../Content/Calculations/Result/TransactionList';
import {
  DEFAULT_TX_FILTERS,
  TxFilters,
} from '../Content/Calculations/Result/TransactionList/FilterRow';
import { tokens } from '../Content/Calculations/tokens';
import '../Content/Calculations/styles.css';
import { subscriptionToDisplayData } from '../data/subscriptionToDisplayData';

interface Props {
  subscription: Subscription;
  bot: Bot | undefined;
  spc: SingleProfitCalculationApiResponse | undefined;
  chartData: ProfitChartApiResponse | undefined;
  shorterCandles: Candle[] | undefined;
}

/**
 * Transactions tab — the profit-result page's transactions section reused
 * verbatim: LiveState renders the filter controls + live position, TransactionList
 * renders the filtered, expandable list. Filter state lives here so it is shared
 * between the two, mirroring Result/index.tsx.
 */
const Transactions = ({
  subscription,
  bot,
  spc,
  chartData,
  shorterCandles,
}: Props) => {
  const displayData = useMemo(
    () =>
      subscriptionToDisplayData(subscription, bot, {
        spc,
        chartData,
        shorterCandles,
      }),
    [subscription, bot, spc, chartData, shorterCandles],
  );
  const [txFilters, setTxFilters] = useState<TxFilters>(DEFAULT_TX_FILTERS);

  return (
    <ResultProvider data={displayData}>
      <div
        style={{
          // Transparent so the content root's profit wash shows through the top.
          background: 'transparent',
          color: tokens.textPrimary,
          fontFamily: tokens.fontSans,
          width: '100%',
          maxWidth: 1400,
          margin: '0 auto',
          boxSizing: 'border-box',
        }}
      >
        <LiveState filters={txFilters} onFiltersChange={setTxFilters} />
        <TransactionList filters={txFilters} />
        <div style={{ height: 32 }} />
      </div>
    </ResultProvider>
  );
};

export default Transactions;
